import { ParamsResponse } from 'interfaces/global.types';
import request from './request';

const notificationService = {
  getAll: (params?: ParamsResponse) => request.get('notifications/', { params }),
  getID: (id?: number) => request.get(`notifications/${id}/`),
  delete: (id?: number) => request.delete(`notifications/${id}/`),
  create: (data?: any) => request.post('notifications/', data),
  update: (id?: number, data?: any) => request.patch(`notifications/${id}/`, data),
};

export default notificationService;
